import { PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IForm } from 'core-components/classes/models/IForm'

import {
  mapContractSignatureProgress,
  mapLRProgressData,
  mapProfilingProgress,
} from '../../services/mapping/mapProgressData'
import { IOnboardingState } from '../models'
import {
  IContractSignatureProgressParams,
  ILRProgressParams,
  IProfilingProgressParams,
} from '../models/progressDataModels'

// ProfilingProgress
export const getProfilingProgressPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IProfilingProgressParams }>
) => {
  const { meta } = action

  state.progressData.profilingProgressData.meta = meta
  state.progressData.profilingProgressData.status = RequestStatus.PENDING
  state.progressData.profilingProgressData.message = ''
}

export const getProfilingProgressRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IProfilingProgressParams }>
) => {
  const { meta } = action

  state.progressData.profilingProgressData.meta = meta
  state.progressData.profilingProgressData.status = RequestStatus.REJECTED
  state.progressData.profilingProgressData.message = action.payload as string
}

export const getProfilingProgressFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IProfilingProgressParams }>
) => {
  const { meta, payload } = action

  state.progressData.profilingProgressData.meta = meta
  state.progressData.profilingProgressData.status = RequestStatus.FULFILLED
  state.progressData.profilingProgressData.message = ''
  if (payload) {
    state.progressData.profilingProgressData.data = mapProfilingProgress(payload)
  }
}

// LRProgress
export const getLRProgressPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: ILRProgressParams }>
) => {
  const { meta } = action

  state.progressData.lrProgressData.meta = meta
  state.progressData.lrProgressData.status = RequestStatus.PENDING
  state.progressData.lrProgressData.message = ''
}

export const getLRProgressRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: ILRProgressParams }>
) => {
  const { meta } = action

  state.progressData.lrProgressData.meta = meta
  state.progressData.lrProgressData.status = RequestStatus.REJECTED
  state.progressData.lrProgressData.message = action.payload as string
}

export const getLRProgressFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: ILRProgressParams }>
) => {
  const { meta, payload } = action

  state.progressData.lrProgressData.meta = meta
  state.progressData.lrProgressData.status = RequestStatus.FULFILLED
  state.progressData.lrProgressData.message = ''
  if (payload) {
    state.progressData.lrProgressData.data = mapLRProgressData(payload)
  }
}

// ContractSignatureProgress
export const getContractSignatureProgressPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IContractSignatureProgressParams }>
) => {
  const { meta } = action

  state.progressData.contractSignatureProgressData.meta = meta
  state.progressData.contractSignatureProgressData.status = RequestStatus.PENDING
  state.progressData.contractSignatureProgressData.message = ''
}

export const getContractSignatureProgressRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IContractSignatureProgressParams }>
) => {
  const { meta } = action

  state.progressData.contractSignatureProgressData.meta = meta
  state.progressData.contractSignatureProgressData.status = RequestStatus.REJECTED
  state.progressData.contractSignatureProgressData.message = action.payload as string
}

export const getContractSignatureProgressFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IContractSignatureProgressParams }>
) => {
  const { meta, payload } = action

  state.progressData.contractSignatureProgressData.meta = meta
  state.progressData.contractSignatureProgressData.status = RequestStatus.FULFILLED
  state.progressData.contractSignatureProgressData.message = ''
  if (payload) {
    state.progressData.contractSignatureProgressData.data = mapContractSignatureProgress(payload)
  }
}
